import React, {Fragment} from 'react'
import {Disclosure, Menu, Transition} from '@headlessui/react'
import {ChevronDownIcon, FilterIcon} from '@heroicons/react/solid'
import {filter, find, includes, map} from 'lodash';


function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export default function ListFilter({filters, makes, onFiltersChanged}) {
    const setFilter = (id) => {

        if (includes(filters, id)) {
            onFiltersChanged(filter(filters, (filter) => filter !== id))
        } else {
            onFiltersChanged([...filters, id])
        }
    }


    return (
        <div className="bg-white">


            {/* Filters */}
            <Disclosure
                as="section"
                aria-labelledby="filter-heading"
                className="relative z-10 border-t border-b border-gray-200 grid items-center"
            >
                <h2 id="filter-heading" className="sr-only">
                    Filters
                </h2>
                <div className="relative col-start-1 row-start-1 py-4">
                    <div className="max-w-7xl mx-auto flex space-x-6 divide-x divide-gray-200 text-sm px-4 sm:px-6 lg:px-8">
                        <div>
                            <Disclosure.Button className="group text-gray-700 font-medium flex items-center">
                                <FilterIcon
                                    className="flex-none w-5 h-5 mr-2 text-gray-400 group-hover:text-gray-500"
                                    aria-hidden="true"
                                />
                                Filters
                            </Disclosure.Button>
                        </div>

                        <div className="hidden md:block md:flex">
                            {map(filters, (filter) => {
                                const make = find(makes, (m) => m.id === filter)
                                return <div className="mr-6">{make.name}</div>
                            })}
                        </div>

                        {filters && filters.length > 0 &&
                        <div className="pl-6">
                            <button type="button" className="text-gray-500" onClick={() => onFiltersChanged([])}>
                                Alles wissen
                            </button>
                        </div>}
                    </div>
                </div>
                <Disclosure.Panel className="border-t border-gray-200 py-10">
                    <div className="max-w-7xl mx-auto grid grid-cols-2 gap-x-4 px-4 text-sm sm:px-6 md:gap-x-6 lg:px-8">
                        <div className="grid grid-cols-1 gap-y-10 auto-rows-min md:grid-cols-2 md:gap-x-6">
                            <fieldset>
                                <legend className="block font-medium">Merk</legend>
                                <div className="pt-6 space-y-6 sm:pt-4 sm:space-y-4">
                                    {map(makes, (make, optionIdx) => {
                                        const selected = includes(filters, make.id);
                                        return (
                                            <div key={make.id} className="flex items-center text-base sm:text-sm cursor-pointer" onClick={() => setFilter(make.id)}>
                                                <Disclosure.Button>
                                                    <input
                                                        id={`make-${make.id}`}
                                                        name="Merk[]"
                                                        defaultValue={make.id}
                                                        type="checkbox"
                                                        className="flex-shrink-0 h-4 w-4 border-gray-300 rounded text-indigo-600 focus:ring-indigo-500"
                                                        defaultChecked={selected}

                                                    />
                                                    <label htmlFor={`price-${optionIdx}`} className="ml-3 min-w-0 flex-1 text-gray-600">
                                                        {make.name}
                                                    </label>
                                                </Disclosure.Button>
                                            </div>
                                        )
                                    })}
                                </div>
                            </fieldset>

                        </div>

                    </div>
                </Disclosure.Panel>

            </Disclosure>
        </div>
)
}
